// User-friendly error message mapping
// Prevents leaking internal implementation details

const errorMessages: Record<string, string> = {
  // Auth errors
  "Invalid login credentials": "Invalid email or password. Please try again.",
  "Email not confirmed": "Please verify your email address before signing in.",
  "User already registered": "An account with this email already exists. Try signing in instead.",
  "Password should be at least 6 characters": "Password must be at least 6 characters long.",
  "Unable to validate email address: invalid format": "Please enter a valid email address.",
  "Signup requires a valid password": "Please enter a valid password.",
  "Email rate limit exceeded": "Too many attempts. Please try again later.",
  "For security purposes, you can only request this once every 60 seconds": "Please wait a moment before trying again.",
  
  // Database errors
  "duplicate key value violates unique constraint": "This record already exists.",
  "violates foreign key constraint": "This operation cannot be completed due to related data.",
  "new row violates row-level security policy": "You don't have permission to perform this action.",
  
  // Network errors
  "Failed to fetch": "Unable to connect. Please check your internet connection.",
  "NetworkError": "Network error. Please check your connection and try again.",
  "Load failed": "Unable to connect. Please try again.",
};

export function getErrorMessage(error: any): string {
  if (!error) return "Something went wrong. Please try again.";
  
  const message = error.message || error.error || String(error);
  
  // Check for exact matches
  if (errorMessages[message]) {
    return errorMessages[message];
  }
  
  // Check for partial matches
  for (const [key, value] of Object.entries(errorMessages)) {
    if (message.toLowerCase().includes(key.toLowerCase())) {
      return value;
    }
  }
  
  // Default fallback - never expose raw error
  return "Something went wrong. Please try again.";
}
